import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from '../blogData';
import { Helmet } from "react-helmet"; // Dynamic SEO ke liye

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) return <div className="text-center py-20">Post Not Found</div>;

  return (
    <div className="bg-white text-black min-h-screen">
      {/* --- DYNAMIC SEO TAGS --- */}
      <Helmet>
        <title>{post.title} | ZYGMA Insights</title>
        <meta name="description" content={post.excerpt || "Learn professional digital growth strategies on the ZYGMA blog."} />
        <meta name="keywords" content={`${post.title}, Worldwide SEO, Global Digital Strategy, ZYGMA Insights`} />
        {/* Open Graph for Social Media Sharing */}
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:type" content="article" />
        <link rel="canonical" href={`https://zygmagrowthsolutions.com/blog/${post.slug}`} />
      </Helmet>

      {/* Breadcrumb */}
      <nav className="max-w-4xl mx-auto px-6 py-4 border-b border-gray-100">
        <Link to="/blog" className="text-blue-600 font-medium">← Back to Blog</Link>
      </nav>

      <article className="max-w-4xl mx-auto px-6 py-12 lg:py-20">
        {/* Title & Date */}
        <h1 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight text-gray-900">
          {post.title}
        </h1>
        <p className="text-gray-500 mb-10 border-l-4 border-blue-600 pl-4 uppercase tracking-widest text-sm font-bold">
          Published: {post.date}
        </p>

        {/* Content Area */}
        <div 
          className="prose prose-lg max-w-none 
                     text-gray-800 leading-relaxed
                     prose-headings:text-black prose-headings:font-bold
                     prose-h3:text-2xl prose-h3:mt-8
                     prose-p:mb-4 prose-strong:text-black"
          dangerouslySetInnerHTML={{ __html: post.content }} 
        />

        {/* Call to Action Box */}
        <div className="mt-16 p-8 bg-gray-50 rounded-2xl border border-gray-200 text-center">
          <h2 className="text-2xl font-bold mb-4">Want to Grow Your Business?</h2>
          <p className="mb-6 text-gray-600 text-lg">Let ZYGMA handle your SEO and Digital Growth while you focus on sales.</p>
          <Link to="/contact" className="inline-block bg-blue-600 text-white px-10 py-4 rounded-lg font-bold hover:bg-blue-700 transition shadow-lg">
            Get a Free Consultation
          </Link>
        </div>
      </article>
    </div>
  );
};

export default BlogPost;